import { useUpdateCompanyStatus } from "@/api/console/companies/useUpdateCompanyStatus";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle
} from "@/components/ui/dialog";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { STATUS } from "@/config/progress";
import toast from "@/lib/toast";
import { SpinnerIosRegular } from "@fluentui/react-icons";
import { Dispatch, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface UpdateCompanyStatusDialogProps {
  open: boolean;
  companyId: number;
  companyName: string;
  status: { id: number; name: string};
  hasImprovementProposal: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

function UpdateCompanyStatusDialog({companyId, companyName, open, setOpen, status, hasImprovementProposal} : UpdateCompanyStatusDialogProps) {
  const { t } = useTranslation();
  const statuses = [
    {
      id: 1,
      name : "SUBMITTED",
    },
    {
      id: 2,
      name : "ASSESSMENT GRADED COMPLETED",
    },
    {
      id: 3,
      name : "ASSESSMENT EVALUATION COMPLETED",
    }
   ];

   const navigate = useNavigate();

  const { trigger: updateStatus, isMutating } = useUpdateCompanyStatus(
    companyId,
    {
      onSuccess: (data) => {
        toast.success(data.message);
        navigate("/console/check-submissions"); 
      },
    },
  );
  
  const [selectedStatus, setSelectedStatus] = useState<string>(status.id.toString());

  const filteredStatuses = statuses.filter((s) => {
    if (!companyId) return false;
    const excludeAssessmentEvaluation =
      !hasImprovementProposal &&
      s.id === STATUS.ASSESSMENT_EVALUATION_COMPLETED;
    const isPreviousStatus = s.id < status.id;
    return isPreviousStatus && !excludeAssessmentEvaluation;
  });

  return (
    <Dialog
      open={open}
      onOpenChange={setOpen}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("update-status")}</DialogTitle>
        </DialogHeader>
        <div className=" flex flex-col p-6">
          <div>
            <div className=" text-lg font-bold">{companyName}</div>
            <div>現在のステータス : {status.name}</div>
          </div>
          <RadioGroup
            className=" mt-5"
            onValueChange={setSelectedStatus}
            value={selectedStatus}
          >
            {filteredStatuses.map((s) => (
              <div
                key={s.id}
                className=" flex flex-row items-center space-x-2 cursor-pointer"
              >
                <RadioGroupItem
                  id={`status-${s.id}`}
                  value={s.id.toString()}
                />
                <label htmlFor={`status-${s.id}`}>{s.name}</label>
              </div>
            ))}
          </RadioGroup>
          <div className=" flex flex-row w-full justify-end mt-6 space-x-3">
            <Button onClick={() => setOpen(false)} variant={"outline"}>
              {t("cancel")}
            </Button>
            <Button
              onClick={() =>
                updateStatus({
                  status: parseInt(selectedStatus),
                })
              }
              LoadingComponent={<SpinnerIosRegular className="animate-spin" />}
              isLoading={isMutating}
            >
              {t("update")}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default UpdateCompanyStatusDialog;
